import { ColDef, ColGroupDef, SortChangedEvent } from 'ag-grid-community';

export const DEFAULT_ROW_HEIGHT = 10;
export const DEFAULT_HEADER_HEIGHT = 20;
export const DEFAULT_FLOATING_FILTER_HEIGHT = 10;
export const DEFAULT_FONT_SIZE = '12px';

export interface ClientGridProps<T> {
  colDefs: (ColDef<T> | ColGroupDef<T>)[];
  rowData?: T[] | null;
  rowHeight?: number;
  headerHeight?: number;
  floatingFilterHeight?: number;
  fontSize?: string | number;
  onClick?: (data: T) => void;
  handleScroll?: () => void;
  loading?: boolean;
  errors?: T[];
  onSortChanged?: (event: SortChangedEvent) => void;
  initialSort?: { colId: string; sort: 'asc' | 'desc' } | null;
}
